import axios from '../../app/common/libs/http';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchAgentTotalStats = createAsyncThunk(
  'dashboard/getAgentTotalStats',
  async ({ from, to, campaignId, userId }) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/insights/agentDashboardStats`,
      {
        from,
        to,
        campaignId,
        userId,
      }
    )
);
